/*
 * Regras puras da listagem de inscrições do administrativo (sem React): categoria
 * visual da situação, ordenação aceita pelo back e montagem dos parâmetros do /paginado.
 */

// Código da situação (TipoInscricaoSituacao) -> categoria visual. Código desconhecido é neutro.
const CATEGORIA_POR_CODIGO = {
    C: 'sucesso',
    S: 'sucesso',
    H: 'sucesso',
    D: 'erro',
    X: 'erro',
    I: 'erro',
    P: 'pendente',
    E: 'atencao',
    F: 'atencao',
    L: 'atencao',
    A: 'info'
};

export const categoriaSituacao = codigo => CATEGORIA_POR_CODIGO[String(codigo || '').toUpperCase()] || 'neutro';

// Campos que o back aceita em `ordem` (o /paginado ignora qualquer outro valor).
export const ORDENS_VALIDAS = ['id', 'cpf', 'nome', 'nomeSocial'];

export const ORDENACAO_PADRAO = {ordem: 'id', ascendente: false};

export const ordemValida = ordem => (ORDENS_VALIDAS.includes(ordem) ? ordem : ORDENACAO_PADRAO.ordem);

export const mesmaOrdenacao = (a, b) => a.ordem === b.ordem && !!a.ascendente === !!b.ascendente;

/*
 * Parâmetros do GET /inscricoes/paginado. `filtros` é o JSON string que o DataGrid monta
 * (campo -> valor, sempre texto); vazio vira "{}".
 */
export const montarParametrosPaginado = (filtros, ordenacao, pagina, tamanhoPagina) => ({
    filtros: filtros ? String(filtros) : '{}',
    ordem: ordemValida(ordenacao && ordenacao.ordem),
    ascendente: !!(ordenacao && ordenacao.ascendente),
    paginaAtual: pagina || 0,
    tamanhoPagina
});

// Lista da API -> opções do filtro por coluna do DataGrid ({label, value}).
export const opcoesFiltro = (lista, campoValor, campoRotulo) =>
    (lista || []).map(item => ({label: item[campoRotulo], value: item[campoValor]}));

// Comparação exata exigida pelo DataGrid para colunas com filterOptions (o filtro padrão é "contém").
export const igualFiltro = (termo, valor) => valor !== undefined && valor !== null && String(valor) === String(termo);
